import React from 'react'
import { includes, isEmpty, map } from 'lodash'
import Spinner from '~/components/Spinner'
import SelectPlan from './SelectPlan'
import CreateAccount from './CreateAccount'
import Billing from './Billing'
import ThankYou from './ThankYou'
import popup from '../../popup'
import userStore from '~/redux/user/store'
import {
  getSubscriptionPlans,
  getInvisiblePlans,
  getDiscountPrice
} from "~/redux/user/subscription";
import { trackGA } from './ga'
import { trackEvent } from '~/tools/analytics/cleverTap'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'
//import Verify from '../../views/Purchase/verify'
import { getToken } from '~/redux/user/tokens'
import { axiosWithKey } from "~/axios"
import { userLanguageSelector } from '~/tools/localization'
import './style.css'
import connect from "~/tools/connect";
import { StripeJS } from '~/views/Popup/views/CreateSubscription/Billing/StripeCCForm/StripeJS';
import { AmazonJS } from '~/components/AmazonPay/AmazonJS'

class SubscriptionView extends React.Component {
  constructor(props) {
    super(props)    
    this.argsPresent = props.args && (props.args.selected !== undefined);
    this.subscriptionInitiated = false
    var user = userStore.getState().user

    this.state = props.state || {
      'current': (!this.argsPresent ? 'selectPlan' : user ? 'billing' : 'createAccount'),
      'paymentHandler': null,
      'metadataMap': {}
    }
    this.trackCT = this.trackCT.bind(this)
  }

  async componentDidMount() {
    await StripeJS();
    await AmazonJS();
    
    if (!this.state.metadataMap.length) {
      this.fetchPageData()
    }
    if (this.plansLoaded)
      return

      // Start the Custom plan section 
      if(window.localStorage.getItem('customPlan') && !window.sessionStorage.getItem('plans')) {  
      const customPlan = JSON.parse(window.localStorage.getItem('customPlan'));
      this.setState({ 'plans': customPlan, 'selectedPlan': this.argsPresent ?  this.findIndex(customPlan, (plan) => plan.id === this.props.args.selected) : 0 })
    } else {
      if(!window.sessionStorage.getItem('plans')){  
        getSubscriptionPlans().then( plans => {
          this.setState({ 'plans': plans, 'selectedPlan': this.argsPresent ?  this.findIndex(plans, (plan) => plan.id === this.props.args.selected) : 0 })
        })
      } else {
          getInvisiblePlans().then( plans => {
            this.setState({ 'plans': plans, 'selectedPlan': this.argsPresent ?  this.findIndex(plans, (plan) => plan.id === this.props.args.selected) : 0 })
            this.getActualPrice()
          })        
      }
    }

    getCountryCode().then(country => {
      if (window.settings.paymentProviders && window.settings.paymentProviders.juspay && window.settings.paymentProviders.juspay.country === country) { // When JusPay enabled

        return this.setState({ paymentHandler: 'juspay' });

      } else { // When JusPay is not enabled then Either ccavenue or SSL or Strip will run
        var providers = window.settings.paymentProviders
        for (var k in providers) {
          if (includes(providers[k].country, country)) {
            return this.setState({ paymentHandler: k })
          }
        }
        for (k in providers) {
          if (includes(providers[k].country, 'ROW')) {
            return this.setState({ paymentHandler: k })
          }
        }
        return this.setState({ paymentHandler: 'stripe' })
    }
    })
    this.plansLoaded = true    
  }

  fetchPageData = () => {
    getToken(token => {
      return axiosWithKey({
        method: "GET",
        url: `${window.settings.apiBaseUrlCached || window.settings.apiBaseUrl}/content/pages?path=/subscribe&languageCode=${userLanguageSelector()}&includeContent=true`,
        headers: { Authorization: token }
      })
        .then(res => {
          const response = res.data.modules[0].metadataMap;
          this.setState({ metadataMap: response, loading: false })
        })
        .catch();
    });
  }

  findIndex(arr, fn) {
    return arr.reduce((carry, item, idx) => {
      if (fn(item, idx)) {
        return idx;
      }
      return carry;
    }, -1);
  }

  canAccess(state) {
    return (
      (state === 'selectPlan') ||
      (state === 'createAccount' && this.isComplete('selectPlan')) ||
      (state === 'billing' && this.isComplete('createAccount') && this.isComplete('selectPlan'))
    )
  }

  isComplete(state) {
    return (
      (state === 'selectPlan' && typeof this.state.selectedPlan === 'number') ||
      (state === 'createAccount' && this.state.user) ||
      (state === 'billing' && false)
    )
  }

  clickChangeToState(state) {
    if (!this.canAccess(state)) return false
    this.setState({ current: state })
    return true
  }

  componentDidUpdate(prevProps, prevState) {
    this.state.plans && trackGA(this, prevProps, prevState)
    if (prevState.selectedPlan !== this.state.selectedPlan) { this.subscriptionInitiated = false }
    if (this.state.paymentHandler) { this.trackCT(prevProps, prevState) }
    if (this.state.plans) {
      if (prevState.current !== 'billing' && this.state.current === 'billing') {
        this.getActualPrice();
      } else if (this.state.current === 'billing' && this.state.current === 'billing' && !this.state.firstPayment) {
        this.getActualPrice()
      }
    }
  }

  render() {

    const metadataMap = this.state.metadataMap
    if (!this.state.plans || isEmpty(metadataMap))
      return (<div className="loading centered"><Spinner/></div>)

    if (this.state.current === 'thankyou')
      return (<div className="subscription centered">{this.thankYouScreen()}</div>)

    var left = (- 100 * [
      'selectPlan', 'createAccount', 'billing'
    ].indexOf(this.state.current)) + '%'

    var titleMap = {
      'selectPlan': [metadataMap.selectPlan, metadataMap.planSelected],
      'createAccount': [metadataMap.createAccount, metadataMap.accountCreated],
      'billing': [metadataMap.addBilling, metadataMap.billingSubscribed]
    }

    return (
      <div className="subscription-view centered">
      { this.state.overlay && 
        <div className='background-overlay' style={this.state.overlay.styles}>
          <div className="background-overlay-message">{this.state.overlay.loading && this.state.overlay.message}</div>
          { this.state.overlay.loading && <Spinner /> }
        </div> }
        <div className="mobile-title">
          <div className="page"><strong>{Object.keys(titleMap).indexOf(this.state.current) + 1}</strong> of 3</div>
          {titleMap[this.state.current][0]}
        </div>

        {this.state.current !== 'selectPlan' &&
          <div
            className="back-button"
            onClick={_ => this.setState({
              current: (this.state.current === 'createAccount' ? 'selectPlan' : 'createAccount')
            })} >
            <i className="ion-android-arrow-back" />
          </div>
        }
        <div className="progress">
          { map(titleMap, (v, k) => (
            <div
              key={k}
              className={
                this.state.current === k ? 'red' :
                  this.isComplete(k) ? 'ticked' : ''
              }
              onClick={_ => this.clickChangeToState(k)} >
              {v[(this.isComplete(k) && this.state.current !== k) ? 1 : 0]}
              <div className="bar site-color site-color-after"></div>
            </div>
          ))}
        </div>
        <div className="screen">
          <div className="slider" style={{ marginLeft: left }}>
            <div className={'slide' + (this.state.current !== 'selectPlan' ? ' hidden' : '')} >
              {this.selectPlanEl()}
            </div>
            <div className={'slide' + (this.state.current !== 'createAccount' ? ' hidden' : '')} >
              {this.createAccountEl()}
            </div>
            <div className={'slide' + (this.state.current !== 'billing' ? ' hidden' : '')} >
              {(this.state.current === 'billing') && this.billingEl()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  trackCT() {
    if (typeof this.state.selectedPlan === 'number' && !this.subscriptionInitiated && this.state.user) {
      const plan = this.state.plans[this.state.selectedPlan]
      const planDetails = plan.planDetails[0];
      const recurringPaymentAmount = planDetails.recurringPaymentAmount ? planDetails.recurringPaymentAmount : 0;
      const amount = planDetails.strikeThroughPrice ? planDetails.strikeThroughPrice : recurringPaymentAmount;
      const discountAmount = amount - recurringPaymentAmount;
      let pageType = document.location.pathname;
      pageType = pageType.substr(1);
      var initiateSubscriptionEventData = {
        paymentHandler: this.state.paymentHandler,
        country: planDetails.countryCode,
        currency: planDetails.recurringPaymentCurrencyCode,
        paymentPlan: plan.name,
        discountAmount: discountAmount,
        discountedAmount: recurringPaymentAmount,
        transactionAmount: recurringPaymentAmount,
        platform: 'Web',
        userId: this.state.user.userId,
        planId: plan.id,
        networkType : window.navigator.connection ? (window.navigator.connection.type ? window.navigator.connection.type : window.navigator.connection.effectiveType) : "wifi" 
      }

      var addToCartEventData ={
        transactionAmount: recurringPaymentAmount,
        paymentPlan: plan.name,
        country: planDetails.countryCode,
        platform: 'Web',
        deviceId: 'Not_Available',
        pageType: pageType
      }
      trackEvent('Subscription Initiated', initiateSubscriptionEventData)
      trackEvent('ADD_TO_CART', addToCartEventData)
      this.subscriptionInitiated = true
    }
  }

  selectPlanEl() {
    return (
      <SelectPlan
        metadataMap={this.state.metadataMap}
        isCurrent={this.state.current === 'selectPlan'}
        plans={this.state.plans}
        selected={this.state.selectedPlan}
        selectPlan={i => {
          if (this.state.selectedPlan === i)
            this.setState({ current: 'createAccount' })
          else
            this.setState({
              selectedPlan: i,
              editingOfferCode: false,
              offerCode: null
            })
        }} />
    )
  }

  createAccountEl() {
    return (
      <CreateAccount
        metadataMap={this.state.metadataMap}
        plan={this.state.plans[this.state.selectedPlan]}
        user={this.state.user}
        offerCode={this.state.offerCode}
        editingOfferCode={this.state.editingOfferCode}

        addCode={c => this.setState({ offerCode: c, editingOfferCode: false })}
        removeCode={c => this.setState({ offerCode: null, editingOfferCode: false })}
        editOfferCode={c => this.setState({ editingOfferCode: c })}

        editPlan={s => { this.setState({ current: 'selectPlan' }) }}
        continue={c => {
          // trackEvent('Signed Up', {registrationType: 'Native'})
          this.setState({ current: 'billing' })
        }}
        goToLogin={_ => popup.login()} />
    )
  }

  billingEl() {
    this.storePlanDetails()
    // if (this.state.user && this.state.user.billingInfo && this.state.user.billingInfo.stripeToken){
    //   return (
    //     <Verify 
    //       metadataMap = {this.state.metadataMap}
    //       plan={this.state.plans[this.state.selectedPlan]}
    //       firstPayment={this.state.firstPayment}
    //       edit={() => this.setState({user : {...this.state.user, billingInfo: {}},updateCard: true})}
    //       offerCode={this.state.offerCode}
    //       success={(data, status) => this.setState({ subscriptionData: data, current: 'thankyou', subscriptionComplete: status})}
    //       subscription={true}
    //       user={this.state.user}
    //     />
    //   )
    // }
   
    return (
      <Billing
        metadataMap={this.state.metadataMap}
        firstPayment={this.state.firstPayment}
        plan={this.state.plans[this.state.selectedPlan]}
        updateCard={this.state.updateCard}
        offerCode={this.state.offerCode}
        editPlan={_ => this.setState({ current: 'selectPlan' })}
        user={this.state.user}
        editPromo={ _ => this.setState({ current: 'createAccount', editingOfferCode: true }) }
        success={ (data, status) => this.setState({ subscriptionData: data, current: 'thankyou', subscriptionComplete: status}) }
        overlay={s => this.setState({ overlay: s })}
      />
    )
  }

  getActualPrice = () => {
    const data = {
      userId: this.state.user && this.state.user.userId,
      planId: this.state.plans && this.state.plans[this.state.selectedPlan].id,
      offerCode: this.state.offerCode && this.state.offerCode.code
    }
    getDiscountPrice(data).then(res => {
      this.setState({ firstPayment: res.data })
    })
  }

  thankYouScreen() {
    return (
      <ThankYou
        metadataMap = {this.state.metadataMap}
        plan={ this.state.plans[this.state.selectedPlan] }
        user={ this.state.user }
        subscriptionComplete = {this.state.subscriptionComplete}
        firstPayment={this.state.firstPayment}
        subscriptionData={this.state.subscriptionData} />
    )
  }
  storePlanDetails() {
    const plan = this.state.plans[this.state.selectedPlan]
    localStorage.setItem('planDetails', JSON.stringify(plan))
  }
}

connect(SubscriptionView, (state) => ({ user: state.user }), userStore)


export default SubscriptionView;